export const API_URL = process.env.REACT_APP_API_URL;
export const STORAGE = "mortgage-support"

export const KEYS = {
    AUTH_ACCESS: 'MORTGAGE_AUTH_ACCESS',
    AUTH_REFRESH: 'MORTGAGE_AUTH_REFRESH',
}

export const URLS = {
    REGISTER: '/register',
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password/:email',
    USER_VERIFICATION: '/user-verification',
    HOME: '/',
    PROFILE: '/personal-dashboard',
    PROFILEDETAILS: '/profile-details',

    MYLOS:'/my-account',
    PROCESSORS: '/processor',
    SUBMITFILE: '/submit-file',
    EMPLOYEEREVIEW: '/employee-review',


    ESCALATION: {
        LIST: '/request-resolution',
        // ADD: '/escalation/add',
        // EDIT: '/escalation/edit/:id',
        // VIEW: '/escalation/view/:id',
    },
    PREORDER: {
        LIST: '/pre-order',
        // ADD: '/pre-order/add',
        // EDIT: '/pre-order/edit/:id',
        // VIEW: '/pre-order/view/:id',
    },

    FUNDING: {
        REQUEST_LIST: '/loan-request',
        SUBMIT_REQUEST: '/submit-loan-request',
    },
    FUNDINGOVERVIEW: {
        LIST: '/loan-tracking',
        SUBMIT_REQUEST: '/loan-tracking-request',
    },
    LENDER:'/lender',
    SCENARIO_COACHES:'/recommended-coaches',
    VENDORS:'/vendors',

    SHOP: '/shop',
}

export const APIS = {
    AUTH: {
        LOGIN: API_URL + '/auth/login',
        LOGOUT: API_URL + '/logout',
        FORGOT_PASSWORD: API_URL + '/forgot/password',
        RESET_PASSWORD: API_URL + '/auth/set/password',
        CHANGE_PASSWORD: API_URL + '/users/password',
        REGISTRATION: API_URL + '/auth/register',
        AVATAR: API_URL + '/users/avatar',
    },
    USER: {
        LOGIN: API_URL + '/auth/login',
        LOGOUT: API_URL + '/logout',
        FORGOT_PASSWORD: API_URL + '/forgot/password',
        RESET_PASSWORD: API_URL + '/set/password',
        CHANGE_PASSWORD: API_URL + '/users/password',
        REGISTRATION: API_URL + '/register',
        AVATAR: API_URL + '/users/avatar',
    }, 
    PROFILE: {
        UPDATE: API_URL + '/users/profile',
        AVATAR_UPDATE: API_URL + '/users/avatar',
        COMPANY_LOGO_UPDATE: API_URL + '/users/company/logo',
    },
    MASTER: {
        GET_LICENSES: API_URL + '/masters/licenses?offset=10', // ?offset=10
        GET_LANGUAGES: API_URL + '/masters/languages?offset=10', // ?offset=10
        
        GET_COMPANY: API_URL + '/companies', // ?offset=10
        GET_MASTER_MODULE: API_URL + '/masters/modules', // ?modules=licenses,languages,states,roles

    }

}

export const ACTIONS = {
    RESET_REDUCER: "ACTIONS/RESET_REDUCER",

    LOADER: {
        FP_STATUS: "ACTIONS/LOADER/FP_STATUS",
    },

    USER: {
        LOGIN: "ACTIONS/USER/LOGIN",
        USER: "ACTIONS/USER/USER",
        LOGOUT: "ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "ACTIONS/USER/RESET_PASSWORD",
        PASSWORD_RESET: "ACTIONS/USER/PASSWORD_RESET",
    },

}

export const SAGA_ACTIONS = {
    USER: {
        LOGIN: "SAGA_ACTIONS/USER/LOGIN",
        LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
        FORGET_PASSWORD: "SAGA_ACTIONS/USER/FORGET_PASSWORD",
        RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
        REGISTER: "SAGA_ACTIONS/USER/REGISTER",
        GET_DESIGNS: "SAGA_ACTIONS/USER/GET_DESIGNS",
        SAVE_DESIGN: "SAGA_ACTIONS/USER/SAVE_DESIGN",
        UPDATE_DESIGN: "SAGA_ACTIONS/USER/UPDATE_DESIGN",

        IMAGE_LIST: "SAGA_ACTIONS/USER/IMAGE_LIST",
        IMAGE_UPLOAD: "SAGA_ACTIONS/USER/IMAGE_UPLOAD",
    },
    PROFILE: {
        UPDATE: "SAGA_ACTIONS/PROFILE/UPDATE",
    },
    MASTER: {
        GET_LICENSES: "SAGA_ACTIONS/MASTER/GET_LICENSES",
        GET_LANGUAGES: "SAGA_ACTIONS/MASTER/GET_LANGUAGES",
        GET_COMPANY: "SAGA_ACTIONS/MASTER/GET_COMPANY",
        GET_MASTER_MODULE: "SAGA_ACTIONS/MASTER/GET_MASTER_MODULE",

    }
}